import React, { FC } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';
import { getHumanizerModeV4Options } from '../constants';

const SelectModeText: FC = () => {
  const { t } = useTranslation('tools');
  const HUMANIZER_MODE_V2_OPTIONS = Object.entries(
    getHumanizerModeV4Options(t),
  );
  return (
    <div>
      <ul className={styles.list}>
        {HUMANIZER_MODE_V2_OPTIONS.map(([key, option]) => {
          return (
            <li key={key} className={styles.list__item}>
              <Typography
                variant={Typographies.BODY_MEDIUM}
                component="div"
                className={styles.text}
              >
                {option.text}
              </Typography>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SelectModeText;
